import React, { useState, useEffect, useRef } from "react";
import { Edit, IdCard, ListCheck, CalendarDays, Gift } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import formatDate from '../../hooks/formatDate';
import { creatLoyalitycard, getLoyaltyCard, getLoyaltyProgram } from "../../services/api";
import Pagination from "../../hooks/Pagination";
import { useAuth } from "../../context/AuthContext";

import toastr from 'toastr';

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";

import { format } from 'date-fns';

export default function LoyaltyCard() {
  const { user } = useAuth();
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const [loyalty_card, setLoyaltyCard] = useState([]);
  const [loyalty_program, setLoyaltyProgram] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cardNumber, setcardNumberGen] = useState('');


  const generateCardNumber = () => {
    // Get current date/time components
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');

    // Combine date/time components (this will be 12 digits)
    const timeDigits = `${month}${day}${hours}${minutes}${seconds}`;

    // Generate random digits to fill remaining space (if needed)
    const randomDigits = Math.floor(Math.random() * 10000).toString().padStart(4, '0');

    // Combine fixed prefix with time digits and random digits
    //const cardNumber = `${user.id}${timeDigits}`.substring(0, 16);
    const cardNumber = `${user.id}${timeDigits}${randomDigits}`.substring(0, 16);
    // Format with spaces for better readability
    const formattedNumber = cardNumber.replace(/(\d{0})/g, '$1').trim();

    return formattedNumber;
  };
  const perPage = 100;
  const fetchLoyaltyCard = async (perPage, currentPage) => {
    try {
      const response = await getLoyaltyCard(perPage, currentPage);
      const data = await response.data;
      setLoyaltyCard(data.data || data); // Adjust based on your API response structure
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {

    const fetchLoyaltyProgram = async () => {
      try {
        const response = await getLoyaltyProgram();
        const data = await response.data;
        setLoyaltyProgram(data.data || data);
      } catch (err) {
        setError(err.message || 'Failed to fetch Loyalty program');
      } finally {
        setLoading(false);
      }
    };
    fetchLoyaltyProgram()
    fetchLoyaltyCard(perPage, currentPage);
  }, [currentPage]);

  const initialFormData = {
    card_id: 0,
    program_id: "",
    status: "active",
    card_number: '',
    card_type: "",
    issue_date: new Date(),
    initial_points: "0",
    expiration_date: new Date(),
  };
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    card_id: 0,
    program_id: "",
    status: "active",
    card_number: cardNumber,
    card_type: "",
    issue_date: new Date(),
    initial_points: "0",
    expiration_date: new Date(),
  });
  const handleOpen = () => {
    setFormData(initialFormData)
    setOpen(!open)
    setcardNumberGen(generateCardNumber())
    setFormData(prev => ({
      ...prev,
      ['card_number']: generateCardNumber()
    }));
  };

  const handleChange = (e, field = '') => {
    let name = '';
    let value = '';
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = field//field.name;
      value = e;
    }
    console.log(e);

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toastr.options = {
      closeButton: true,
      progressBar: true,
      timeOut: 3000,
      positionClass: 'toast-top-center'
    };
    if (formData.program_id === '') {
      toastr.error('Select Program Name', { timeOut: 2000 });
      return false
    }
    if (formData.card_number === '') {
      toastr.error('Enter card number', { timeOut: 2000 });
      return false
    }
    if (formData.card_type === '') {
      toastr.error('Select card type', { timeOut: 2000 });
      return false
    }

    // const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    // const numbers = Array.from({ length: 990 }, (_, i) => i + 1);
    // const results = [];

    // for (const number of numbers) {
    //   let dumpcard = {
    //     "card_id": 0,
    //     "program_id": "3",
    //     "status": "active",
    //     "card_number": generateCardNumber(),
    //     "card_type": "premium",
    //     "issue_date": "2025-05-16T02:36:58.982Z",
    //     "initial_points": "0",
    //     "expiration_date": "2030-01-01T02:36:00.000Z"
    //   }
    //   const response = await creatLoyalitycard(dumpcard);
    //   console.log(dumpcard);
    //   console.log(response);
    //   await sleep(1000); // 1 second delay between calls
    // }

    // console.log(formData);
    // return false

    try {
      const response = await creatLoyalitycard(formData);
      if (response.status.success) {
        fetchLoyaltyCard(perPage, currentPage);
        setOpen(false)
        toastr.success(response.message)
        setFormData(initialFormData)

      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      // console.error("Error:", error);
      toastr.error("Add Card failed. Please try again.");
    }
  };
  const handleEdit = ((item) => {
    setFormData({
      card_id: item.card_id,
      program_id: item.program_id,
      status: item.status,
      card_number: item.card_number,
      card_type: item.card_type,
      issue_date: new Date(item.issue_date),
      initial_points: item.initial_points,
      expiration_date: new Date(item.expiration_date),
    });
    setOpen(true)
  })

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedRows(loyalty_card.map(item => item.card_number));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (e, card_number) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedRows([...selectedRows, card_number]);
    } else {
      setSelectedRows(selectedRows.filter(name => name !== card_number));
      setSelectAll(false);
    }
  };
  const PrintCard = () => {
    if (selectedRows.length > 0) {
      let params = selectedRows.join(',')
      window.open(`/loyalty/printcards?${params.toString()}`, '_blank', 'noopener,noreferrer');
    } else {
      alert('No items selected');
    }
  };
  return (
    <>

      <div className="flex flex-col md:flex-row gap-4 md:gap-4">


        {/* <div className="flex justify-center items-center min-h-screen bg-gray-100">
          <div className="w-[400px] h-[250px] rounded-xl bg-gradient-to-br from-black to-gray-900 text-white p-6 relative shadow-xl overflow-hidden">
          
            <div className="absolute inset-0">
              <svg className="w-full h-full opacity-10" viewBox="0 0 400 250" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <radialGradient id="grad" cx="50%" cy="50%" r="100%">
                    <stop offset="0%" stopColor="#666" stopOpacity="0.2" />
                    <stop offset="100%" stopColor="#000" stopOpacity="0" />
                  </radialGradient>
                </defs>
                <rect width="100%" height="100%" fill="url(#grad)" />
              </svg>
            </div>

            <div className="absolute left-2 top-1/2 transform -translate-y-1/2 flex flex-col items-center">
              <img src="/logocard.png" alt="Logo" className="w-50 h-auto rotate-[-90deg]" />
            </div>

            <div className="absolute right-6 top-8 text-right">
              <h1 className="text-4xl font-bold text-yellow-400 drop-shadow-md">VIP</h1>
              <div className="text-yellow-300 font-semibold text-sm bg-gradient-to-r from-yellow-700 via-yellow-500 to-yellow-300 px-2 py-1 rounded mt-1 inline-block">
                CLUB CARD
              </div>
            </div>

            <div className="absolute bottom-12 left-6 text-yellow-300 font-mono tracking-widest text-lg">
              1234 5678 9012 3456
            </div>

            <div className="absolute bottom-6 left-6 text-yellow-300 font-mono text-sm">
              VIP TILL 03/26
            </div>

            <div className="absolute top-4 right-4 text-2xl font-bold text-gradient bg-gradient-to-br from-blue-400 to-cyan-500 bg-clip-text text-transparent">
              g
            </div>
          </div>
        </div> */}

        {error && <div style={{ color: 'red' }}>{error}</div>}

        {open && (

          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">

              <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-lg shadow-xl min-w-[300px] w-[60vw] max-w-[900px] max-h-[95vh] flex flex-col">
                  <div className="flex justify-between items-center border-b px-6 py-4">
                    <h3 className="text-lg font-semibold">{(formData.card_id > 0) ? 'Edit' : 'Add'} Card</h3>
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="p-4 space-y-4 overflow-y-auto flex-grow">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium mb-1">Program Name</label>
                        <div className="relative">
                          <select name="program_id" value={formData.program_id || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          >
                            <option value="" disabled>Select</option>
                            {loyalty_program.map((item) => (
                              <option key={item.program_id} value={item.program_id}>{item.program_name}</option>
                            ))}
                          </select>
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Card Number </label>
                        <div className="relative">
                          <input
                            type="text"
                            name="card_number"
                            value={formData.card_number || cardNumber}
                            onChange={handleChange}
                            placeholder="OZS-9876565656"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <IdCard className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Card Type</label>
                        <div className="relative">
                          <select name="card_type" value={formData.card_type || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          >
                            <option value="" disabled>Select</option>
                            <option value="standard">Standard</option>
                            <option value="premium">Premium</option>
                            <option value="family">Family</option>
                            <option value="corporate">corporate</option>
                          </select>
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Initial Points</label>
                        <div className="relative">
                          <input
                            type="text"
                            name="initial_points"
                            value={formData.initial_points || ""}
                            onChange={handleChange}
                            placeholder="0"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Issue Date</label>
                        <div className="relative">
                          <Flatpickr
                            value={formData.issue_date}
                            // onChange={([date]) => handleChange(date, 'issue_date')}
                            onChange={([date]) => {
                              handleChange(date, 'issue_date')

                              if (formData.issue_date && formData.expiration_date && formData.expiration_date < formData.issue_date) {
                                handleChange(date, 'expiration_date')
                              }
                            }}
                            options={{
                              minDate: 'today',
                              enableTime: true,
                              time_24hr: true,
                              defaultDate: null,
                              altFormat: 'Y-m-d H:i (UTCZ)',
                              dateFormat: "d/m/Y H:i", // Format: DD/MM/YYYY
                            }}
                            placeholder="Select a date"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Expiry Date</label>
                        <div className="relative">
                          <Flatpickr
                            value={formData.expiration_date}
                            onChange={([date]) => handleChange(date, 'expiration_date')}
                            options={{
                              enableTime: true,
                              time_24hr: true,
                              defaultDate: null,
                              altFormat: 'Y-m-d H:i (UTCZ)',
                              dateFormat: "d/m/Y H:i", // Format: DD/MM/YYYY
                              // minDate: format(formData.issue_date, 'yyyy-mm-dd'),
                            }}
                            placeholder="Select a date"
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          />

                          <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">Status</label>
                        <div className="relative">
                          <select name="status" value={formData.status || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                          >
                            <option value="" disabled>Select</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="lost">Lost</option>
                            <option value="stolen">Stolen</option>
                            <option value="expired">Expired</option>
                          </select>
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="flex justify-end border-t px-6 py-4">
                    <button
                      type="submit"
                      className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </>
        )}

        <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

          <div className="grid grid-flow-col grid-rows-3 gap-4">
            <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Loyalty Card</h2></div>
            {selectedRows.length > 0 && (
              <div className="row-start-1 row-end-4 text-right">
                <button type="button" onClick={PrintCard} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Print</button>
              </div>
            )}
            <div className="row-start-1 row-end-4 text-right">
              <button type="button" onClick={handleOpen} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Add New</button>
            </div>
          </div>
          <div className="overflow-auto">

            <table className="w-full text-sm text-left">
              <thead className="text-gray-700 bg-gray-100">
                <tr>
                  <th className="p-3">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out rounded"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                      <span className="ml-2">All</span>
                    </label>
                  </th>
                  <th className="p-3">Program Name</th>
                  <th className="p-3">Card Number</th>
                  <th className="p-3">Card Type</th>
                  <th className="p-3">Issue Date</th>
                  <th className="p-3">Expiration Date</th>
                  <th className="p-3">Created On</th>
                  <th className="p-3 text-center">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {loading ? (
                  <>
                    <tr>
                      <td className="p-3" colSpan={8}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {!loading && loyalty_card.length > 0 ? (
                      loyalty_card.map((item) => (
                        <tr key={item.card_id}>
                          <td className="p-3">
                            <label className="inline-flex items-center">
                              <input
                                type="checkbox"
                                className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out rounded"
                                checked={selectedRows.includes(item.card_number)}
                                onChange={(e) => handleRowSelect(e, item.card_number)}
                              />
                            </label>
                          </td>
                          <td className="p-3">{item.program_name}</td>
                          <td className="p-3">{item.card_number.replace(/(.{4})/g, "$1 ").trim()}</td>
                          <td className="p-3">{item.card_type}</td>
                          <td className="p-3">{formatDate(item.issue_date)}</td>
                          <td className="p-3">{formatDate(item.expiration_date)}</td>
                          <td className="p-3">{item.createdDate}</td>
                          <td className="p-3 text-center space-x-2">
                            <button onClick={() => handleEdit(item)} className="text-[#f4a406] hover:underline inline-flex items-center gap-1">
                              <Edit size={16} />
                            </button>
                            {/* <button className="text-red-500 hover:underline inline-flex items-center gap-1">
                              <Trash2 size={16} />
                            </button> */}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="p-3" colSpan={7}>
                          No record found
                        </td>
                      </tr>
                    )}

                  </>
                )}

              </tbody>
            </table>
            <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </div>

    </>
  );
}
